export default __webpack_public_path__ + "static/media/IMG8736.399ef988.jpg";